// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormUtils = require("./PropertyWizardFormUtils.bs.js");
let PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
let PropertyWizardRelay__Description__Message = require("./PropertyWizardRelay__Description__Message.bs.js");
let PropertyWizardRelay__Description__Subject = require("./PropertyWizardRelay__Description__Subject.bs.js");
let PropertyWizardRelay__Description__Website = require("./PropertyWizardRelay__Description__Website.bs.js");
let PropertyWizardRelayDescription_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescription_draft_graphql.bs.js");
let PropertyWizardRelay__Description__Description = require("./PropertyWizardRelay__Description__Description.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayDescription_formState_graphql = require("../../../__generated__/PropertyWizardRelayDescription_formState_graphql.bs.js");
let PropertyWizardRelay__Description__DisplayNeighborhood = require("./PropertyWizardRelay__Description__DisplayNeighborhood.bs.js");

let convertFragment = PropertyWizardRelayDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescription_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescription_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescription_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescription_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayDescription_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Description(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescription_draft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1, props.formState);
  let subjectIsValid = PropertyWizardFormRelay__Validators__Description.Subject.useIsValid(draft.fragmentRefs);
  let stepHasBeenTouched = formState.stepDescriptionTouched;
  let subject = PropertyWizardFormUtils.useFormControl({
    TAG: "Draft",
    _0: (dp, value) => ({
      chapterPreferenceMlsComingSoonActivated: dp.chapterPreferenceMlsComingSoonActivated,
      draftProperty: dp.draftProperty,
      message: dp.message,
      serverDraftId: dp.serverDraftId,
      status: dp.status,
      subject: value,
      timeZone: dp.timeZone
    })
  }, stepHasBeenTouched, draft.subject, subjectIsValid);
  let messageIsValid = PropertyWizardFormRelay__Validators__Description.Message.useIsValid(draft.fragmentRefs);
  let message = PropertyWizardFormUtils.useFormControl({
    TAG: "Draft",
    _0: (dp, value) => ({
      chapterPreferenceMlsComingSoonActivated: dp.chapterPreferenceMlsComingSoonActivated,
      draftProperty: dp.draftProperty,
      message: value,
      serverDraftId: dp.serverDraftId,
      status: dp.status,
      subject: dp.subject,
      timeZone: dp.timeZone
    })
  }, stepHasBeenTouched, draft.message, messageIsValid);
  let match$1 = subject.focused;
  let tmp;
  if (match$1) {
    if (typeof mode !== "object") {
      tmp = TipBoxes.PropertyWizard.headline;
    } else {
      switch (mode.TAG) {
        case "Edit" :
          tmp = TipBoxes.PropertyWizard.headline;
          break;
        case "Rebroadcast" :
          tmp = JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RebroadcastHeadlineTipBox.make, {});
          break;
        case "BroadcastQuietSeller" :
          tmp = undefined;
          break;
      }
    }
  } else {
    tmp = undefined;
  }
  let subjectField = JsxRuntime.jsx(FormV5.FormSection.make, {
    tipbox: tmp,
    children: JsxRuntime.jsx(PropertyWizardRelay__Description__Subject.make, {
      subject: subject
    })
  });
  let match$2 = message.focused;
  let tmp$1;
  if (match$2) {
    if (typeof mode !== "object") {
      tmp$1 = TipBoxes.PropertyWizard.tanMessage;
    } else {
      switch (mode.TAG) {
        case "Edit" :
          tmp$1 = TipBoxes.PropertyWizard.tanMessage;
          break;
        case "Rebroadcast" :
          tmp$1 = JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RebroadcastMessageTipBox.make, {});
          break;
        case "BroadcastQuietSeller" :
          tmp$1 = undefined;
          break;
      }
    }
  } else {
    tmp$1 = undefined;
  }
  let messageField = JsxRuntime.jsx(FormV5.FormSection.make, {
    tipbox: tmp$1,
    children: JsxRuntime.jsx(PropertyWizardRelay__Description__Message.make, {
      draft: draft.fragmentRefs,
      message: message
    })
  });
  let displayNeighborhoodField = JsxRuntime.jsx(FormV5.FormSection.make, {
    children: JsxRuntime.jsx(PropertyWizardRelay__Description__DisplayNeighborhood.make, {
      draft: draft.fragmentRefs,
      formState: formState.fragmentRefs,
      stepHasBeenTouched: stepHasBeenTouched
    })
  });
  let websiteField = JsxRuntime.jsx(FormV5.FormSection.make, {
    children: JsxRuntime.jsx(PropertyWizardRelay__Description__Website.make, {
      draft: draft.fragmentRefs,
      stepHasBeenTouched: stepHasBeenTouched
    })
  });
  let descriptionField = JsxRuntime.jsx(FormV5.FormSection.make, {
    children: JsxRuntime.jsx(PropertyWizardRelay__Description__Description.make, {
      draft: draft.fragmentRefs,
      stepHasBeenTouched: stepHasBeenTouched
    })
  });
  let tmp$2;
  let exit = 0;
  if (typeof mode !== "object" || mode.TAG !== "Rebroadcast") {
    exit = 1;
  } else {
    tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        subjectField,
        messageField,
        displayNeighborhoodField,
        websiteField,
        descriptionField
      ]
    });
  }
  if (exit === 1) {
    tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        subjectField,
        displayNeighborhoodField,
        websiteField,
        descriptionField,
        messageField
      ]
    });
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: tmp$2
  });
}

let FormSection;

let Elements;

let Validators;

let FormUtils;

let FormControl;

let SubjectField;

let DisplayNeighborhoodField;

let DescriptionField;

let MessageField;

let WebsiteField;

let make = PropertyWizardRelay__Description;

exports.FormSection = FormSection;
exports.Elements = Elements;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.FormControl = FormControl;
exports.SubjectField = SubjectField;
exports.DisplayNeighborhoodField = DisplayNeighborhoodField;
exports.DescriptionField = DescriptionField;
exports.MessageField = MessageField;
exports.WebsiteField = WebsiteField;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* FormV5 Not a pure module */
